export default function Spinner({ size = 20, text }) {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label={text || 'Laden…'}
      className="flex items-center gap-2.5 px-4 py-6 text-ink-2 text-[14.5px]"
    >
      <span
        aria-hidden="true"
        className="inline-block shrink-0 rounded-full border-2 border-line border-t-accent animate-[spin_0.8s_linear_infinite]"
        style={{ width: size, height: size }}
      />
      {text && <span>{text}</span>}
    </div>
  );
}
